import type { AppleEedCapabilities } from '../realtime/contracts';

export type AppleEedEntitlements = {
  appleEedAllowAdditionalData: boolean;
  appleEedAllowMediaUpload: boolean;
};

export type AppleEedDataPanelActions = {
  showPanel: boolean;
  canRetrieveAdditionalData: boolean;
  canRequestMedia: boolean;
};

export function canUseAppleEedAdditionalData(
  appleEedAllowAdditionalData: boolean,
  appleEedAdditionalDataExpiresAtUtc: string | null,
  nowMs: number = Date.now(),
): boolean {
  if (!appleEedAllowAdditionalData || appleEedAdditionalDataExpiresAtUtc === null) {
    return false;
  }

  const expiresAtMs = Date.parse(appleEedAdditionalDataExpiresAtUtc);
  return !Number.isNaN(expiresAtMs) && nowMs < expiresAtMs;
}

export function appleEedAdditionalDataHasExpired(
  appleEedAdditionalDataExpiresAtUtc: string | null,
  nowMs: number = Date.now(),
): boolean {
  if (appleEedAdditionalDataExpiresAtUtc === null) {
    return false;
  }

  const expiresAtMs = Date.parse(appleEedAdditionalDataExpiresAtUtc);
  return !Number.isNaN(expiresAtMs) && nowMs >= expiresAtMs;
}

export function canUseAppleEedVideoActions(appleEedAllowLiveVideo: boolean, incidentIsReadOnly: boolean): boolean {
  return appleEedAllowLiveVideo && !incidentIsReadOnly;
}

export function canUseAppleEedMediaUpload(appleEedAllowMediaUpload: boolean, incidentIsReadOnly: boolean): boolean {
  return appleEedAllowMediaUpload && !incidentIsReadOnly;
}

export function getAppleEedDataPanelActions(
  entitlements: AppleEedEntitlements,
  appleEedCapabilities: AppleEedCapabilities | null,
  appleEedAdditionalDataExpiresAtUtc: string | null,
  incidentIsReadOnly: boolean,
  nowMs: number = Date.now(),
): AppleEedDataPanelActions {
  const canRetrieveAdditionalData =
    canUseAppleEedAdditionalData(entitlements.appleEedAllowAdditionalData, appleEedAdditionalDataExpiresAtUtc, nowMs) &&
    appleEedCapabilities?.additionalData === true;
  const canRequestMedia =
    canUseAppleEedMediaUpload(entitlements.appleEedAllowMediaUpload, incidentIsReadOnly) &&
    appleEedCapabilities?.mediaUpload === true;

  return {
    showPanel: canRetrieveAdditionalData || canRequestMedia,
    canRetrieveAdditionalData,
    canRequestMedia,
  };
}
